









































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbInput, mdbAlert, mdbBtn, mdbIcon } from '@folky-tools/mdbvue';
import { EntityOwner } from '@/models/common/entity-owner';
import { usersService } from '@/services';
import { is_email_valid as isEmailValid } from 'node-email-validation';
import { required, email } from 'vuelidate/lib/validators';

@Component({
    components: {
        mdbRow,
        mdbCol,
        mdbInput,
        mdbAlert,
        mdbBtn,
        mdbIcon
    },
    validations: {
        owner: {
            email: {
                required,
                email,
                customEmail: (value, model) => {
                    if (typeof value === 'undefined' || value === null || value === '') {
                        return true;
                    }
                    return isEmailValid(value);
                }
            }
        }
    }
})
export default class ChangeEntityOwner extends Vue {
    @Prop(EntityOwner) private owner!: EntityOwner;
    @Prop({ default: false }) private sendInvitationEnabled!: boolean;
    @Prop({ default: false }) private sendingInvitation!: boolean;
    private emailExists: boolean = true;

    private inviteUser(): void {
        this.$emit('inviteUser', this.owner);
    }

    private async hasErrors(): Promise<boolean> {
        this.emailExists = true;

        this.$v.owner.$touch();
        if (this.$v.owner.$error) {
            return true;
        }

        const user = await usersService.getUserByEmail(this.owner.email!);

        this.emailExists = user.id !== 0;

        if (this.emailExists) {
            this.owner.id = user.id;
            this.owner.email = user.email;
        }

        return !this.emailExists;
    }
}
